module.exports = __webpack_public_path__ + "img/leaf-maple.32543887.svg";